import React from 'react';
import { Panel } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import PropTypes from 'prop-types';
import FileUpload from '../../../components/FileUpload/index';
import last from 'lodash/last';
import SmallLoader from '../../../components/SmallLoader';

const FILETYPES = [
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    'application/pdf',
    'image/png',
    'image/jpeg',
    'image/gif',
    'text/plain',
    'text/csv',
    'video/avi',
    'video/x-msvideo',
    'video/msvideo',
    'video/mpeg',
    'video/mp4',
    'video/quicktime',
    'video/x-ms-wmv',
    'video/webm',
];

const attachmentNameFormatter = (cell, row) => <a href={row.url}>{last(row.name.split('/'))}</a>;

const indexFormatter = (cell, row, obj, index) => index + 1;

const AttachmentsInfo = ({ attachments, abnormalityId, isPending }) => {
    const tableOptions = {
        noDataText: isPending ? <SmallLoader /> : 'No data to display. Please refine your search.',
    };

    return (
        <Panel
            collapsible
            defaultExpanded={attachments && attachments.length > 0}
            header="Attachments"
        >
            <BootstrapTable
                data={attachments} // title + Link
                maxHeight={500}
                hover
                scrollTop="Top"
                options={tableOptions}
            >
                <TableHeaderColumn dataField="id" isKey width="40" dataFormat={indexFormatter}>
                    #
                </TableHeaderColumn>
                <TableHeaderColumn dataField="name" dataFormat={attachmentNameFormatter}>
                    Attachment
                </TableHeaderColumn>
            </BootstrapTable>
            <FileUpload
                abnormalityId={abnormalityId}
                url={`/api/files/abnormality/${abnormalityId}`}
                allowedFileTypes={FILETYPES}
            />
        </Panel>
    );
};

AttachmentsInfo.propTypes = {
    attachments: PropTypes.array,
    abnormalityId: PropTypes.string,
};

export default AttachmentsInfo;
